import $ from 'jquery';
import MicroModal from 'micromodal';

$(document).on('click', '.js-modal-route', function () {
  MicroModal.show($(this).data('modal'), {
    onShow: (modal) => {
      const $slickNext = $(`#${modal.id} .slick-arrow[aria-label='next']`);
      if ($slickNext.length != 0) {
        $slickNext[0].focus();
      }
    },
  });
});

// Manual modal to modal routing
$('.js-menu-route').on('click', function () {
  const next = $(this).attr('data-modal');
  if ($(this).parents('.modal').length) {
    const current = $(this).parents('.modal').attr('id');
    if (current) {
      $(`#${next}`).find('.js-menu-back').attr('data-modal', current);
    } else {
      $(`#${next}`).find('.js-menu-back').removeAttr('data-modal');
    }
    MicroModal.close(current);
  }
  MicroModal.show(next);
});

$('.js-menu-back').on('click', function () {
  const current = $(this).parents('.modal').attr('id');
  const next = $(this).attr('data-modal');
  $(this).removeAttr('data-modal');
  MicroModal.close(current);
  if (next) {
    MicroModal.show(next);
  }
});

// Modal Footer Form Submission

$('.modal-submit-footer').on('click', '.js-send', function () {
  $(this).parents('.modal').find('.gform_wrapper form').submit();
});
